import React from 'react';
import { CircleCheckIcon, CircleXIcon, CompassIcon, LayersIcon, PrinterIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceIntro, differencePillars } from '../data/content';
import { CtaButton } from './CtaButton';
import { Highlight } from './Highlight';
const pillarIcons = [CompassIcon, LayersIcon, PrinterIcon];
const pillarColors = ['bg-blue-600', 'bg-red-500', 'bg-green-600'];
const steps = [{
  word: 'Explore.',
  color: 'text-blue-600'
}, {
  word: 'Choose.',
  color: 'text-red-500'
}, {
  word: 'Print.',
  color: 'text-violet-600'
}, {
  word: 'Teach.',
  color: 'text-green-600'
}];
export function Difference() {
  return <section className="w-full bg-paper px-5 py-20 sm:py-28" data-id="element-45" data-mp="3diqzbax4478k">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="3igsj5y2d4al3">
        <div className="mx-auto max-w-3xl text-center" data-id="element-47" data-mp="3ihlpwz1bn038">
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-royal" data-id="element-48" data-mp="1bqma476zzo1j">
            The CAREER READY™ Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-49" data-mp="1gm1kgp5sr1t7">
            From Last-Minute Planning to{' '}
            <Highlight data-id="element-50" data-mp="1f928xdyyxsok">Walking Into Class Prepared.</Highlight>
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-center text-base leading-relaxed text-ink-soft" data-id="element-51" data-mp="1sznk0gi6kybw">
          <p className="font-display text-xl font-bold text-ink" data-id="element-52" data-mp="1o2faf4b3m2m9">
            You already know career readiness matters.
          </p>
          {differenceIntro.map(paragraph => <p key={paragraph} data-id="element-53" data-mp="wbhlmbbur262">{paragraph}</p>)}
        </div>

        <div className="mt-16" data-id="element-54" data-mp="wd2bhnn81wxl">
          <h3 className="text-center font-display text-3xl font-black tracking-tight sm:text-4xl" data-id="element-55" data-mp="1aaqz338obi6c">
            {steps.map(step => <span key={step.word} className={`${step.color} mx-1 inline-block`} data-id="element-56" data-mp="15ami7c3uslfl">
                {step.word}
              </span>)}
          </h3>
          <dl className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-57" data-mp="2lrgwbwv4cznt">
            {differencePillars.map((pillar, index) => {
            const Icon = pillarIcons[index];
            return <div key={pillar.title} className="rounded-2xl border-2 border-ink bg-white p-6 shadow-pop" data-id="element-58" data-mp="2oqpg0c0v873n" data-mpi={index}>
                  <span className={`inline-flex h-11 w-11 items-center justify-center rounded-xl text-white ${pillarColors[index]}`} data-id="element-59" data-mp="2sr13rxoiynjc">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-60" data-mp="32qrurpdvmkeo" />
                  </span>
                  <dt className="mt-4 font-display text-lg font-bold leading-snug text-ink" data-id="element-61" data-mp="2539rgu2ziai2">
                    {pillar.title}
                  </dt>
                  <dd className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-62" data-mp="2a34cwi3zq7vq">
                    {pillar.text}
                  </dd>
                </div>;
          })}
          </dl>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2" data-id="element-63" data-mp="2jsxpnmfvct1k">
          <div className="rounded-3xl bg-paper-deep p-7 sm:p-9" data-id="element-64" data-mp="1md1p4e73zo2x">
            <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-ink-soft" data-id="element-65" data-mp="1manxygfjuw0n">
              The cost of improvising
            </span>
            <h3 className="mt-2 font-display text-3xl font-black tracking-tight text-ink/70" data-id="element-66" data-mp="1jslxipkxa2ju">
              BEFORE
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-67" data-mp="1etsgin6fftex">
              What planning from scratch quietly takes from your week.
            </p>
            <ul className="mt-7 space-y-3" data-id="element-68" data-mp="14vl32ebcjtho">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-ink-soft" data-id="element-69" data-mp="14xfm1n325bj4">
                  <CircleXIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-70" data-mp="w2rlubccak16" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-ink bg-royal p-7 text-white shadow-pop-lg sm:p-9" data-id="element-71" data-mp="r1kci7ujtcse">
            <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-sun" data-id="element-72" data-mp="m2qx29vpbbpl">
              The CAREER READY™ system
            </span>
            <h3 className="mt-2 font-display text-3xl font-black tracking-tight" data-id="element-73" data-mp="d3nfxbg3h6dq">
              WITH CAREER READY™
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-white/80" data-id="element-74" data-mp="11vbgfpvgcm1j">
              Walk into your next lesson with a clear starting point.
            </p>
            <ul className="mt-7 space-y-3" data-id="element-75" data-mp="t315u7gnaejr">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-sm font-medium leading-relaxed" data-id="element-76" data-mp="x3tfv2xccnh3">
                  <CircleCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sun" aria-hidden="true" data-id="element-77" data-mp="j41wemo22evp" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-78" data-mp="o0sc38vy78gl">
          <p className="mx-auto max-w-2xl font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-79" data-mp="a4f54tp1ipgd">
            You don’t need another collection of lesson ideas.{' '}
            <span className="text-royal" data-id="element-80" data-mp="24gv7hjeptjfy">
              You need materials you can actually use.
            </span>
          </p>
          <CtaButton href="#offer" className="mt-8" data-id="element-81" data-mp="28hovecs5qy8u" />
        </div>
      </div>
    </section>;
}